// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1R0g7","tab":"Tabs_tab__3TPv0","tabActive":"Tabs_tabActive__Oo51l"};